<template>
  <ClientOnly>
    <Teleport to="body">
      <div
        class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 opacity-50 cursor-wait"
      >
        <AtomsLoadingSpinner />
      </div>
    </Teleport>
  </ClientOnly>
</template>

<style></style>

<script setup>
const route = useRoute();
onMounted(() => {
  // If route path contains 'new-neighborhoods' disable
  setTimeout(() => {
    if (!route.path.includes("new-neighborhoods")) {
      window.scrollTo(0, 0);
    }
  }, 1000);
});
</script>
